const translateFields = {
  surName: 'surname',
  firstName: 'name',
  patronymic: 'patronymicName',
  // noPatronymic: 'noPatronymic:',
  dateBirthday: 'birthDay',
  stateCode: 'stateCode',

  typeDocument: 'docTypeId',
  seria: 'docSeries',
  numDoc: 'docNumber',
  dateDoc: 'docIssueDate',
  count: 'dependentsNumber',
  region: 'liveRegionId',
  education: 'educationId',
  marital: 'maritalId',

  employment_type: 'jobCategoryId',
  position_level: 'positionId',
  job_region: 'jobRegionId',
  ent_segment: 'entSegmentCode',
  military_status_id: 'militaryStatusId',
  workExpiriens: 'employmentMonth',
  avgIncome: 'salary',
  summCredit: 'amount'
}

const idField = {
  surName: 1,
  firstName: 2,
  patronymic: 3,
  noPatronymic: 4,
  stateCode: 5,
  dateBirthday: 6,
  typeDocument: 7,
  seria: 8,
  numDoc: 9,
  dateDoc: 10,
  count: 11,
  region: 12,
  education: 13,
  marital: 14,
  employment_type: 15,
  position_level: 16,
  job_region: 17,
  ent_segment: 18,
  military_status_id: 19,
  workExpiriens: 20,
  avgIncome: 21,
  summCredit: 22
}

export { translateFields, idField }